import classNames from 'classnames'
import 'react-reflex/styles.css'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { paneMaxHeight } from '../../../../pages/[lang]/portal/lessons/preparation/[lessonId]'
import { TextProvider } from '../../../../pages/[lang]/portal/materials/detail/[materialId]'
import { TAB } from '../../../materials/const'
import { FileUploadBody } from '../../materials/FileUploadBody'
import MaterialInsightBody from '../../materials/MaterialInsightBody'
import MaterialMobileBottomTab from '../../materials/MaterialMobileBottomTab'
import { QuestionSelectPanel } from '../../materials/QuestionSelect/QuestionSelectPanel'
import { DocNoteTabPanel } from '../../review/DocNoteTabPanel'

interface OneBodyProps {
  material?: any
  expressions?: any
  isReview?: any
  currentTab?: any
  setCurrentTab?: any
  lesson?: any
  materialRef?: any
  iframeRef?: any
  currentUser?: any
  isEditable?: any
  setIsEditable?: any
  setTabData?: any
  answer?: any
  setAnswer?: any
  selectedShareState: any
  setSelectedShareState: any
  activeQuestionId: any
  setActiveQuestionId: any
  lessonId?: any
}

const OneBody = ({
  material,
  expressions,
  isReview,
  currentTab,
  setCurrentTab,
  lesson,
  materialRef,
  iframeRef,
  currentUser,
  isEditable,
  setIsEditable,
  setTabData,
  answer,
  setAnswer,
  selectedShareState,
  setSelectedShareState,
  activeQuestionId,
  setActiveQuestionId,
  lessonId,
}: OneBodyProps) => {
  const isFreeTalkingOrWriting = lesson?.course?.free_talking || lesson?.course?.is_writing
  const isWebview = useIsWebview()
  const { t } = useTranslation()
  return (
    <div
      style={{ maxHeight: isFreeTalkingOrWriting ? '' : paneMaxHeight }}
      className={classNames('no-scrollbar', isFreeTalkingOrWriting ? 'h-full' : '')}
    >
      {currentTab == TAB.INSIGHT && (
        <div className="mt-[16px]">
          <TextProvider>
            <MaterialInsightBody
              materialData={lesson}
              materialId={lesson?.course.id}
              isLesson={isReview}
              setTabData={setTabData}
              isInsightButton={true}
            />
            {lesson.course?.mp3_link && <MaterialMobileBottomTab course={lesson?.course} />}
          </TextProvider>
        </div>
      )}
      {currentTab === TAB.UPLOAD_FILE && (
        <div className="mt-[16px] h-full">
          {isWebview ? (
            <div className="h-full">
              {lesson.material_link ? (
                <div className="flex h-full flex-col">
                  <div className="mb-[20px] flex flex-col p-16">
                    <span className="text-[20px] font-bold">{t(n_lesson_prep.tab_upload)}</span>
                    <span className="text-[14px] font-medium">{t(n_lesson_prep.upload_desc3)}</span>
                  </div>
                  <div style={{ height: '8px' }} className="w-full bg-gray-50"></div>
                  <iframe
                    key={lesson.material_link}
                    ref={materialRef}
                    src={lesson.material_link}
                    className="h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex h-full flex-col">
                  <div className="mb-[20px] flex flex-col p-16">
                    <span className="text-[20px] font-bold">{t(n_lesson_prep.tab_upload)}</span>
                    <span className="text-[14px] font-medium">{t(n_lesson_prep.upload_desc3)}</span>
                  </div>
                  <div style={{ height: '8px' }} className="mb-[48px] w-full bg-gray-50"></div>
                  <div
                    className={classNames(
                      [isWebview ? '' : 'bg-gray-50'],
                      'flex flex-col items-start justify-start space-y-8 rounded-[8px] p-16 text-gray-700'
                    )}
                  >
                    <div>
                      <span className="text-[20px] font-bold text-black">{t(n_lesson_prep.upload_info_title)}</span>
                    </div>
                    <ul className="pl-16">
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info1)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info2)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info3)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info4)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info5)}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <FileUploadBody materialRef={materialRef} lesson={lesson} />
          )}
        </div>
      )}

      {currentTab === TAB.UPLOAD_LINK && (
        <div className="mt-[16px] h-full">
          {isWebview ? (
            <div className="h-full">
              {lesson.material_link ? (
                <div className="flex h-full flex-col">
                  <div className="mb-[20px] flex flex-col p-16">
                    <span className="text-[20px] font-bold">{t(n_lesson_prep.tab_upload)}</span>
                    <span className="text-[14px] font-medium">{t(n_lesson_prep.upload_desc3)}</span>
                  </div>
                  <div style={{ height: '8px' }} className="w-full bg-gray-50"></div>
                  <iframe
                    key={lesson.material_link}
                    ref={materialRef}
                    src={lesson.material_link}
                    className="h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col">
                  <div className="mb-[20px] flex flex-col p-16">
                    <span className="text-[20px] font-bold">{t(n_lesson_prep.tab_upload)}</span>
                    <span className="text-[14px] font-medium">{t(n_lesson_prep.upload_desc3)}</span>
                  </div>
                  <div style={{ height: '8px' }} className="mb-[48px] w-full bg-gray-50"></div>
                  <div
                    className={classNames(
                      [isWebview ? '' : 'bg-gray-50'],
                      'flex flex-col items-start justify-start space-y-8 rounded-[8px] p-16 text-gray-700'
                    )}
                  >
                    <div>
                      <span className="text-[20px] font-bold text-black">{t(n_lesson_prep.upload_info_title)}</span>
                    </div>
                    <ul className="pl-16">
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info1)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info2)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info3)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info4)}</li>
                      <li className="text-14 list-disc font-medium text-black">{t(n_lesson_prep.upload_info5)}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <FileUploadBody materialRef={materialRef} lesson={lesson} />
          )}
        </div>
      )}
      {currentTab === TAB.QUESTION_SELECT && (
        <div className="mt-[16px]">
          <QuestionSelectPanel
            currentUser={currentUser}
            isReview={isReview}
            isLesson={isReview}
            isEditable={isEditable}
            setIsEditable={setIsEditable}
            setTabData={setTabData}
            answer={answer}
            setAnswer={setAnswer}
            id={lessonId}
            selectedShareState={selectedShareState}
            setSelectedShareState={setSelectedShareState}
            activeQuestionId={activeQuestionId}
            setActiveQuestionId={setActiveQuestionId}
          />
        </div>
      )}
      {currentTab === TAB.NOTE && (
        <DocNoteTabPanel
          documentUrl={lesson?.document_url}
          ringledocUrl={lesson?.ringledoc_url}
          iframeRef={iframeRef}
          ringleDocToken={lesson?.ringledoc}
          currentUser={currentUser}
          specialLesson={lesson?.special_lesson}
          height={'calc(100vh - 123px)'}
          style={'border-0 w-h-full w-full h-full'}
        />
      )}
    </div>
  )
}

export default OneBody
